import API_BASE_URL from "../config";

/** Download a file served by the backend (CSV/XLSX exports, …) with the session
 * cookie and save it as `filename`. Throws an Error carrying `status` when the
 * server refuses, so the caller can show it like any other API error. */
export async function downloadApiFile(path, filename) {
  const res = await fetch(`${API_BASE_URL}${path}`);
  if (!res.ok) {
    const error = new Error(`Export failed (${res.status})`);
    error.status = res.status;
    throw error;
  }
  const url = URL.createObjectURL(await res.blob());
  try {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
  } finally {
    URL.revokeObjectURL(url);
  }
}
